import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "@/features/auth/AuthContext";
import { EventProvider } from "@/features/event/EventContext";
import { AppRouter } from "@/router/AppRouter";

/**
 * Raiz do app depois do scaffold da Foundation (Agent 1) — router (React
 * Router v7, modo declarativo, `basename="/ui"` porque a app é servida sob
 * esse prefixo pelo FastAPI, ver `vite.config.ts`) + contexto de sessão
 * (`AuthProvider`, alimenta `RequireAuth` e o resto do app via `useAuth`) +
 * contexto de evento ativo (`EventProvider`, depende de `AuthProvider` estar
 * por fora — só busca `/api/eventos/ativo` quando autenticado).
 *
 * `AppProviders` (`src/app/providers.tsx`, da Foundation) já cuida de
 * QueryClient/Tooltip/Toaster/tema um nível acima, em `main.tsx` — não
 * precisa entrar aqui de novo.
 */
function App() {
  return (
    <BrowserRouter basename="/ui">
      <AuthProvider>
        <EventProvider>
          <AppRouter />
        </EventProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
